import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {TranslationSupportiveLanguage} from "../../../models/translation.model";
import {Observable, Subject} from "rxjs";
import { MatDialogRef } from "@angular/material/dialog";
import {TranslationService} from "../../../services/translation.service";
import {SnackBarService} from "@core/services/snack-bar.service";
import {FileManagementService} from "@core/services/file-management.service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {takeUntil} from "rxjs/operators";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {select, Store} from "@ngrx/store";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {QueryProvider} from "@shared/queries/query-provider";
import {StorageSettings} from "../../../models/translation.constants";
import {hasFeature} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';

@Component({
    standalone: false,
    selector: 'particle-translation-convert-currency-dialog',
  templateUrl: './translation-convert-currency-dialog.component.html',
  styleUrls: ['./translation-convert-currency-dialog.component.scss']
})
export class TranslationConvertCurrencyDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  isFileScanned: boolean;
  fileToUpload: File;
  taxformsSupportiveLanguage: TranslationSupportiveLanguage[] = [];
  private language$: any;
  unsubscribe$ = new Subject<void>();
  isCheckFileFormat: boolean = true;
  toLanguage: string;
  fileIdByUploading: string = null;
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  translationId: string;
  storageSettings: string = 'Stored';
  storageOptions = StorageSettings;
  hasFeature$: Observable<any>;
  hasKPMGFeature: boolean = false;

  constructor(public dialogRef: MatDialogRef<TranslationConvertCurrencyDialogComponent>,
              private translationService: TranslationService,
              private snackBarService: SnackBarService,
              private queryStore: Store<IQueryState>,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private securityStore: Store<SecurityState>) {
    this.isFileScanned = false;
    this.toLanguage = '';
  }

  ngOnInit() {
    this.translationId = this.data.input.translationId;

    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));

    this.hasFeature$.pipe(takeUntil(this.unsubscribe$)).subscribe(x => {
      this.hasKPMGFeature = x('KPMG');
      if (this.hasKPMGFeature) {
        this.storageSettings = StorageSettings.NonStored;
      } else {
        this.storageSettings = StorageSettings.Stored;
      }
    });


    this.language$ = this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unsubscribe$));
    this.language$.subscribe(language => {
      if (language) {
        this.taxformsSupportiveLanguage = language;
        if (this.taxformsSupportiveLanguage && this.taxformsSupportiveLanguage.length > 0) {
          this.taxformsSupportiveLanguage = this.translationService.sortTranslationSupportiveLanguage(this.taxformsSupportiveLanguage);
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.supportiveLanguageQueryKey, {});
  }

  handleFileInput = () => {
    const expectedType: any[] = ['.pdf'];
    const fileFormatOutput = this.fileManagementService.handleFileInput(
      this.fileToUpload,
      expectedType
    );
    if (fileFormatOutput) {

      this.isCheckFileFormat = true;
    } else {
      this.isCheckFileFormat = false;
      this.fileToUpload = null;
    }
  }

  onOkClicked(): boolean {
    if (!this.fileToUpload) {
      this.snackBarService.showError('Please select a file.');
      return;
    }

    if (this.isFileScanned && !this.toLanguage) {
      this.snackBarService.showError('Please select a language.');
      return false;
    }
    if (this.translationService.isOcrNotSupportiveLanguageSelected(this.toLanguage) && this.isFileScanned) {
      this.snackBarService.showError('The language in the scanned document you are uploading is not supported by our OCR engine.\n' +
        'Please upload an electronic version of the document.');
      return false;
    }

    this.data.input.formConfig = {
      isFileScanned: this.isFileScanned,
      toLanguage: this.toLanguage,
      fileId: this.fileIdByUploading,
      fileName: this.fileToUpload.name,
      storageSettings: this.storageSettings
    };
    if (this.fileToUpload) {
      this.fileUploader();
      return false;
    }
    return false;
  }

  fileUploader() {
    this.fuseSplashScreenService.show();
    this.translationService.uploadClientFile(this.fileToUpload, this.translationId).pipe(takeUntil(this.unsubscribe$)).subscribe(fileId => {
      if(fileId) {
        this.fuseSplashScreenService.hide();
        this.data.input.formConfig.fileId = fileId;
        this.dialogRef.close({
          action: 'ok',
          data: this.data
        });
      }
    });
  }


  ngOnDestroy() {
  }
}
